import React from "react";
import {HtmlDisplay} from "../../Components/Display";
import {Button, ButtonLinkStyle} from "../../Components/Inputs";
import {GridCell, gridConstants, GridContainer} from "../../Components/Grid";
import {isNullOrUndefined} from "../../Utilities/commonUtilities";
import {ORDER_TYPE} from "../Order/orderConstants";
import {CheckBoxItem} from "../../Components/Inputs/CheckboxField";
import {isTerminalOrderStatus} from "@containers/Library/libraryUtility";
import {isFimcAdmin} from "@utilities/LocalStorage/storageUtilities";

interface LibraryQueueItemProps {
    catalogId: string;
    details: string;
    handleDelete?: () => void;
    handleViewOrder?: (orderId: string, catalogId: string) => void;
    handleSelectedItemsChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isSelected?: boolean;
    orderId?: string;
    orderType?: string | number;
    orderStatus?: string;
    queueItemId: string;
    title: string;

    [key: string]: unknown;
}


export const LibraryQueueItem = ({
                                     catalogId,
                                     details,
                                     handleDelete,
                                     handleViewOrder,
                                     handleSelectedItemsChange,
                                     isSelected,
                                     orderId,
                                     orderType,
                                     orderStatus,
                                     queueItemId,
                                     title,
                                 }: LibraryQueueItemProps) => {


    const isAnOrder = !isNullOrUndefined(orderId);
    const isAnOrderWithTerminalStatus = orderStatus && isTerminalOrderStatus(Number(orderStatus)) && isAnOrder;

    const handleClickViewOrder = () => handleViewOrder?.(orderId ?? '', catalogId);

    return <>
        <GridContainer className={`catalog__item`} hasMarginX>

            <GridCell small_columns={gridConstants.column.TWO} medium_columns={gridConstants.column.ONE}>
                {
                    queueItemId &&
                    <CheckBoxItem checked={isSelected} hideLabel label={`Select ${title}`} name={`cb${queueItemId}`}
                                  onChange={handleSelectedItemsChange} value={queueItemId}/>
                }
            </GridCell>
            <GridCell small_columns={gridConstants.column.TEN} medium_columns={gridConstants.column.ELEVEN}>

                <h3 className={`margin--bottomNone`}>{title}</h3>

                <HtmlDisplay html={details}/>
                
                {
                    handleDelete &&  !isAnOrder  &&
                    <Button isCollapsed label={`Cancel Request`} name={`btnDelete${catalogId}`} onClick={handleDelete}/>
                }

                {
                    handleDelete && (isFimcAdmin() && isAnOrderWithTerminalStatus) &&
                    <Button isCollapsed label={`Remove Queue Item`} name={`btnDelete${catalogId}`} onClick={handleDelete}/>
                }

                {
                    handleViewOrder && !isNullOrUndefined(orderId) &&
                    <ButtonLinkStyle hasSpacing isCollapsed
                                     label={orderType === ORDER_TYPE.SpecialOrderRequest.toString() ? `(View Special Order)` : `View Order`}
                                     name={`btnViewOrder${catalogId}`}
                                     onClick={handleClickViewOrder}/>
                }
            </GridCell>
        </GridContainer>
    </>;
};
